import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { validLegacyLinkOrigin } from '../utils/helpers';
import { BaseMessageHandler } from './base-message-handler';
import { formulateAppMessageResult, onStatusError } from './messageHandlingUtils';
/**
 * Responsible for handling chat messages
 */
var ChatMessageHandler = /** @class */ (function (_super) {
    __extends(ChatMessageHandler, _super);
    function ChatMessageHandler(appSdkHost, chatService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.chatService = chatService;
        return _this;
    }
    ChatMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.chat.openChat, function (_, params) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.chatService.openChat(params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, formulateAppMessageResult(true)];
                }
            });
        }); }, {
            errorCallback: function (error, scenario) { return onStatusError(SdkMessageTypes.chat.openChat, error, scenario); },
        });
    };
    ChatMessageHandler.prototype.validateDependencies = function () {
        if (!this.chatService) {
            throw 'No ChatService provided';
        }
    };
    return ChatMessageHandler;
}(BaseMessageHandler));
export { ChatMessageHandler };
var ChatLegacyLinkHandler = /** @class */ (function () {
    function ChatLegacyLinkHandler(chatService) {
        this.chatService = chatService;
    }
    ChatLegacyLinkHandler.prototype.tryGetDataFromLink = function (url) {
        var _a;
        if (!this.chatService) {
            return null;
        }
        if (url.origin != validLegacyLinkOrigin || url.pathname != '/l/chat/0/0') {
            return null;
        }
        var members = (_a = url.searchParams.get('users')) === null || _a === void 0 ? void 0 : _a.split(',');
        if (!members) {
            return null;
        }
        var topic = url.searchParams.get('topicName') || undefined;
        var message = url.searchParams.get('message') || undefined;
        return {
            members: members,
            topic: topic,
            message: message,
        };
    };
    ChatLegacyLinkHandler.prototype.executeData = function (data) {
        return this.chatService.openChat(data);
    };
    return ChatLegacyLinkHandler;
}());
export { ChatLegacyLinkHandler };
//# sourceMappingURL=chat-message-handler.js.map